import { render, staticRenderFns } from "./newReport.vue?vue&type=template&id=d1fa4760&"
import script from "./newReport.vue?vue&type=script&lang=js&"
export * from "./newReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports